module.exports = "<p>\n  add-user works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/auth/add-user/add-user.component.html
// module id = ../../../../../src/app/pos/auth/add-user/add-user.component.html
// module chunks = main